/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Payment Method
 * @export
 * @interface SAPPaymentMethod
 */
export interface SAPPaymentMethod {
    /**
     * Payment Method Code
     * @type {string}
     * @memberof SAPPaymentMethod
     */
    code: string;
    /**
     * Payment Method Name
     * @type {string}
     * @memberof SAPPaymentMethod
     */
    name: string;
}

/**
 * Check if a given object implements the SAPPaymentMethod interface.
 */
export function instanceOfSAPPaymentMethod(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function SAPPaymentMethodFromJSON(json: any): SAPPaymentMethod {
    return SAPPaymentMethodFromJSONTyped(json, false);
}

export function SAPPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPPaymentMethod {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
    };
}

export function SAPPaymentMethodToJSON(value?: SAPPaymentMethod | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}

